import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const UserAvatarWrapper = styled(Box)`
  cursor: pointer;
`

export const UserAvatarIcon = styled(Box)`
  padding-left: 4px;
`
